module.exports = __webpack_public_path__ + "static/img/Video-Wall.d880adb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Video-Wall.jpg
// module id = fXYa
// module chunks = 11